import { ServiceMetricsDataCellProps } from '../types';

const ServiceMetricsTeamNameCell = ({
  mosaicTeamId,
  _customRowProps,
}: ServiceMetricsDataCellProps) => {
  const { teamHash } = _customRowProps;
  const teamName = teamHash?.[mosaicTeamId]?.name || 'Loading Team...';

  return <span>{teamName}</span>;
};

export default ServiceMetricsTeamNameCell;
